import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Clock, MapPin, CheckSquare } from 'lucide-react';
const bonuses = [{
  icon: Clock,
  title: 'Guía rápida: Primer estampado en 24 hs',
  color: 'text-accent-yellow',
  price: '$3.990'
}, {
  icon: MapPin,
  title: 'Lista de proveedores en Argentina',
  color: 'text-accent-pink',
  price: '$3.990'
}, {
  icon: CheckSquare,
  title: 'Checklist de estampado perfecto paso a paso',
  color: 'text-accent-cyan',
  price: '$3.070'
}];
export function BonusSection() {
  return <section className="py-12 bg-dark relative overflow-hidden" data-id="element-28">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent-yellow/10 via-dark to-dark pointer-events-none" data-id="element-29" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto bg-card/80 backdrop-blur-sm border-2 border-dashed border-accent-yellow/50 rounded-3xl p-5 md:p-8" data-id="element-31">
          <div className="text-center mb-6" data-id="element-32">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-yellow/20 mb-4" data-id="element-33">
              <Gift className="w-8 h-8 text-accent-yellow" data-id="element-34" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-35">
              🎁 ADEMÁS, LLEVÁS ESTOS{' '}
              <span className="text-accent-yellow" data-id="element-36">BONOS EXCLUSIVOS</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-37">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="bg-darker/50 rounded-xl p-5 border border-white/10 flex flex-col items-center text-center hover:bg-darker transition-colors" data-id="element-38">
                <bonus.icon className={`w-10 h-10 mb-3 ${bonus.color}`} data-id="element-39" />
                <h3 className="text-lg font-bold text-gray-100 font-sans uppercase tracking-wide" data-id="element-40">
                  Bono {index + 1}
                </h3>
                <p className="text-base text-gray-300 mt-1 font-medium" data-id="element-41">
                  {bonus.title}
                </p>
                <span className={`mt-3 text-sm font-bold ${bonus.color} bg-white/5 px-3 py-1 rounded-full`} data-id="element-42">
                  Valor: {bonus.price}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-6 text-center" data-id="element-43">
            <div className="inline-flex items-center gap-3 bg-darker/80 border border-accent-yellow/30 rounded-2xl px-8 py-4" data-id="element-44">
              <span className="text-gray-400 text-lg" data-id="element-45">
                Valor total de los bonos:
              </span>
              <span className="text-2xl md:text-3xl font-bold text-accent-yellow" data-id="element-46">
                $11.050
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}